import React, { useEffect } from "react";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { ApplicationState } from "../../../store";
import { SampleExamLog } from "../../../types/sampleExamLog";
import { getSampleExamLogs, exportSampleExamLogs } from "../../../store/sampleExamLogs/actions";
import SampleExamLogComponent from "./SampleExamLogComponent";

interface SampleExamLogContainerState {
    getSampleExamLogs: () => void;
    exportSampleExamLogs: (filters?: any) => void;
    sampleExamLogs: SampleExamLog[];
    loading: boolean;
    error?: string;
}

const mapStateToProps = ({ sampleExamLogs: { sampleExamLogs, loading, error } }: ApplicationState) => {
    return ({
        sampleExamLogs,
        loading,
        error
    });
};

const mapDispatchToProps = (dispatch: Dispatch) => {
    return bindActionCreators({ getSampleExamLogs, exportSampleExamLogs }, dispatch);
};

const SampleExamLogContainer = ({ getSampleExamLogs, exportSampleExamLogs, sampleExamLogs, loading, error, }: SampleExamLogContainerState) => {
    useEffect(() => {
        getSampleExamLogs();
    }, [getSampleExamLogs]);

    return (
        <SampleExamLogComponent
            loading={loading}
            error={error}
            sampleExamLogs={sampleExamLogs}
            exportSampleExamLogs={exportSampleExamLogs}
        ></SampleExamLogComponent>
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SampleExamLogContainer);